import { TrailersTable } from '@/components/TrailersTable'
import { EquipmentStatus, isValidTrailer, type Trailer, useTrailers } from '@/models/equipment'
import { RosterKind } from './FillJumpProvider'
import { RosterFrame } from './RosterFrame'

// The confirm checks only look at active equipment.
function isComplete(trailer: Trailer): boolean {
  return trailer.status !== EquipmentStatus.ACTIVE || isValidTrailer(trailer)
}

export function TrailersRoster({ orgId }: { orgId: string }) {
  const { trailers, isLoading } = useTrailers({ orgId, shouldFetchAllPages: true })

  return (
    <RosterFrame
      title="Trailers"
      kind={RosterKind.TRAILERS}
      noun="trailer"
      rows={trailers}
      isLoading={isLoading}
      isComplete={isComplete}
      renderTable={(items, setItems, header) => (
        <TrailersTable
          trailers={items}
          setTrailers={setItems}
          orgId={orgId}
          enforceCarrierRequired
          searchable
          compact
          {...header}
        />
      )}
    />
  )
}
